import React from 'react';
import { ArrowLeft, X } from 'phosphor-react';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../ui/ProgressBar';

interface QuizProgressProps {
  currentStep: number;
  totalSteps: number;
  progress: number;
  onBack: () => void;
}

export default function QuizProgress({ currentStep, totalSteps, progress, onBack }: QuizProgressProps) {
  const navigate = useNavigate();

  return (
    <header className="px-5 pt-12 pb-4">
      <div className="max-w-lg mx-auto">
        <div className="mb-4 flex items-center justify-between">
          {currentStep === 0 ? (
            <>
              <div className="w-9" />
              <button
                onClick={() => navigate('/dashboard')}
                className="flex items-center gap-1.5 p-2 -mr-2 text-nude-400 dark:text-gray-500
                           hover:text-gray-600 dark:hover:text-gray-300 rounded-xl transition-colors text-sm"
                aria-label="Sair do quiz"
              >
                <X className="w-4 h-4" />
                <span>Sair</span>
              </button>
            </>
          ) : (
            <>
              <button
                onClick={onBack}
                className="p-2 -ml-2 text-nude-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-xl transition-colors"
                aria-label="Voltar etapa"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <div className="w-9" />
            </>
          )}
        </div>

        <ProgressBar
          valor={progress}
          barraClassName="bg-gradient-to-r from-blush-400 to-blush-500"
          label={`Etapa ${currentStep + 1} de ${totalSteps}`}
        />

        <p className="mt-3 text-xs text-nude-400 dark:text-gray-500 font-medium">
          Etapa {currentStep + 1} de {totalSteps}
        </p>
      </div>
    </header>
  );
}
